import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=143799ff&scoped=true"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143799ff",
  null
  
)

export default component.exports